/**
 * Copyright (c) 2018 Honeywell International Inc. All Rights Reserved.
 * Honeywell and its product names are among the trademarks and/or service marks owned by Honeywell International, Inc., or its subsidiaries.
 *
 * For patent information, see http://www.hsmpats.com.
 */

import React from 'react';
import APIClient from '../../common/APIClient';
import { withApplicationContext, withCustomerSiteContext } from '../../common/HOCs';

export const SiteContext = React.createContext();
export const SiteConsumer = SiteContext.Consumer;

class SiteProvider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedRow: null,
      fetchSites: null,
    };
  }

  render() {
    return (
      <SiteContext.Provider
        value={{
          // state vars
          sites: this.state.sites,
          selectedRows: this.state.selectedRows,
          isConfirmDeleteModalOpen: this.state.isConfirmDeleteModalOpen,
          isConfirmSingleDeleteModalOpen: this.state.isConfirmSingleDeleteModalOpen,

          // api methods
          fetchSites: this.fetchSites,
          setSelectedRows: this.setSelectedRows,
          getIdToken: this.getIdToken,
          createSite: this.createSite,
          editSite: this.editSite,
          deleteSites: this.deleteSites,
          deleteSite: this.deleteSite,
          setSelectedSite: this.setSelectedSite,
          clearSelectedSites: this.clearSelectedSites,
          toggleConfirmDeleteSitesModal: this.toggleConfirmDeleteSitesModal,
          toggleConfirmSingleDeleteSiteModal: this.toggleConfirmSingleDeleteSiteModal,
        }}
      >
        {this.props.children}
      </SiteContext.Provider>
    );
  }

  createSite = async (createSiteForm) => {
    try {
      const response = await APIClient.createSite(
        createSiteForm,
        this.props.appContext.user.idToken,
        this.props.custSiteContext.selectedCustomer
      );
      this.props.appContext.setNotification(
        `Site ${createSiteForm.siteName} was created.`,
        'success'
      );
      this.props.custSiteContext.getSiteList();
    } catch (err) {
      return this.props.appContext.handleModalError(err);
    }
  };

  editSite = async (editSiteForm) => {
    try {
      const response = await APIClient.editSite(
        editSiteForm,
        this.props.appContext.user.idToken,
        this.props.custSiteContext.selectedCustomer
      );
      this.props.appContext.setNotification(
        `Site ${editSiteForm.siteName} was created.`,
        'success'
      );
    } catch (err) {
      return this.props.appContext.handleModalError(err);
    }
  };

  deleteSites = async () => {
    try {
      let message = '';
      let siteIds = '';
      let siteCount = 0;
      const siteArray = this.state.selectedRows;
      if (siteArray.length > 1) {
        siteArray.forEach(function (site) {
          if (siteCount > 0) {
            siteIds = `${siteIds};${site.identifier}`;
          } else {
            siteIds = site.identifier;
          }
          siteCount++;
        });
        message = 'Sites deleted successfully.';
      } else {
        siteIds = siteArray[0].identifier;
        message = 'Site deleted successfully.';
      }
      const response = await APIClient.deleteSites(
        siteIds,
        this.props.appContext.user.idToken,
        this.props.custSiteContext.selectedCustomer
      );
      this.setState({
        isConfirmDeleteModalOpen: !this.state.isConfirmDeleteModalOpen,
        selectedRows: [],
      });
      this.props.appContext.setNotification(message, 'success');
      this.props.custSiteContext.getSiteList();
    } catch (err) {
      this.setState({
        isConfirmDeleteModalOpen: !this.state.isConfirmDeleteModalOpen,
        selectedRows: [],
      });
      return this.props.appContext.handleError(err);
    }
  };

  deleteSite = async () => {
    try {
      const message = 'Site deleted successfully.';
      const response = await APIClient.deleteSites(
        this.state.selectedSite.identifier,
        this.props.appContext.user.idToken,
        this.props.custSiteContext.selectedCustomer
      );
      this.setState({
        isConfirmSingleDeleteModalOpen: !this.state.isConfirmSingleDeleteModalOpen,
        selectedRows: [],
      });
      this.props.appContext.setNotification(message, 'success');
      this.props.custSiteContext.getSiteList();
    } catch (err) {
      this.setState({
        isConfirmSingleDeleteModalOpen: !this.state.isConfirmSingleDeleteModalOpen,
        selectedRows: [],
      });
      return this.props.appContext.handleError(err);
    }
  };

  fetchSites = async (signal) => {
    let sites = [];
    try {
      // get the selected customer
      sites = await APIClient.fetchSites(
        this.props.appContext.user.idToken,
        this.props.custSiteContext.selectedCustomer,
        signal
      );
      sites = sites.response;
    } catch (err) {
      if (err.name !== 'AbortError') {
        this.props.appContext.handleError(err);
        console.error(err);
      }
    }
    this.setState({ sites });
    return sites;
  };

  toggleConfirmDeleteSitesModal = () => {
    this.setState({ isConfirmDeleteModalOpen: !this.state.isConfirmDeleteModalOpen });
  };

  toggleConfirmSingleDeleteSiteModal = () => {
    this.setState({ isConfirmSingleDeleteModalOpen: !this.state.isConfirmSingleDeleteModalOpen });
  };

  clearSelectedSites = () => {
    this.setState({ selectedRows: [] });
  };

  getIdToken = () => {
    return this.props.appContext.user.idToken;
  };

  setSelectedRows = (selectedRows) => {
    this.setState({ selectedRows });
  };

  setSelectedSite = async (site) => {
    this.setState({ selectedSite: site });
  };
}

export default withApplicationContext(withCustomerSiteContext(SiteProvider));
